module.exports = __webpack_public_path__ + "tea_box_mockup+packaging_design_flowers_hibisci_flos_josif_pancic_moc_bilja.jpg?9f4ca577a4fb18bb3ead7bc556c2389a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/tea_box_mockup+packaging_design_flowers_hibisci_flos_josif_pancic_moc_bilja.jpg
// module id = 82
// module chunks = 0